module.exports = __webpack_public_path__ + "img/kehu_2@2x.dc181c43.png";